import { render } from "./CompaniaEmailsRemitentes.vue?vue&type=template&id=a288bea8&scoped=true"
import script from "./CompaniaEmailsRemitentes.vue?vue&type=script&lang=js"
export * from "./CompaniaEmailsRemitentes.vue?vue&type=script&lang=js"

import "./CompaniaEmailsRemitentes.vue?vue&type=style&index=0&id=a288bea8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a288bea8"]])

export default __exports__